<template>
  <div class="container" :style="zoomfactor">
    <p ref="content" id="content">
      <slot>
        眼泪的错觉 - 乔海清/王露凝
        词：乔海清
        曲：乔海清
        女：眼泪的错觉 哭泣的依恋
        爱在昨天 不停的想念
        花蕊的凋谢 情感的善变
        誓言飘过 无所谓语言
        眼泪的错觉 哭泣的依恋
        爱在昨天 不停的想念
        花蕊的凋谢 情感的善变
        誓言飘过 无所谓语言
        为什么要分手 为什么抛弃所有
        为什么剩我一人孤独等候
        能不能再爱我 能不能陪着我
        能不能永远一生不放弃我
        为什么要分手 为什么抛弃所有
        为什么剩我一人孤独等候
        能不能再爱我 能不能陪着我
        能不能永远一生不放弃我
        男：时光已经停留 爱人已经远走
        花蕊凋谢的接受
        让寂寞搁浅 挥挥手
        女：眼泪的错觉 哭泣的依恋
        爱在昨天 不停的想念
        花蕊的凋谢 情感的善变
        誓言飘过 无所谓语言
        为什么要分手 为什么抛弃所有
        为什么剩我一人孤独等候
        能不能再爱我 能不能陪着我
        能不能永远一生不放弃我
        为什么要分手 为什么抛弃所有
        为什么剩我一人孤独等候
        能不能再爱我 能不能陪着我
        能不能永远一生不放弃我
        男：时光已经停留 爱人已经远走
        花蕊凋谢的接受
        让寂寞搁浅 挥挥手
        女：眼泪的错觉 哭泣的依恋
        爱在昨天 不停的想念
        花蕊的凋谢 情感的善变
        誓言飘过 无所谓语言
        眼泪的错觉 哭泣的依恋
      </slot>
    </p>
    <span class="dot" v-show="showEllipsis" :style="calcBottom">
      <b></b>
      <b></b>
      <b></b>
    </span>
  </div>
</template>

<script>
export default {
  name: 'TextEllipsis',
  props: {
    textHeight: {
      type: Number,
      default: 160
    }
  },
  data () {
    return {
      content: {},
      showEllipsis: false,
      fontSize: 14,
      lineNumber: 5
    }
  },
  methods: {
    getStyle (el, attr) {
      // 获取元素具体高度
      return getComputedStyle
        ? window.getComputedStyle(el, null)[attr]
        : el.currentStyle(attr)
    },
    calcHeight () {
      this.$nextTick(() => {
        let textContent = document.getElementById('content')
        let textContentHeight =
          parseInt(this.getStyle(textContent, 'height')) || 0 // 文本实际高度
        this.showEllipsis = textContentHeight > this.textHeight
      })
    }
  },
  computed: {
    zoomfactor () {
      return {
        maxHeight: this.textHeight + 'px',
        fontSize: this.fontSize + 'px',
        // lineHeight: Math.round(this.textHeight / (14 * 5)) + 0.5
        lineHeight: this.textHeight / (this.fontSize * this.lineNumber)
      }
    },
    calcBottom () {
      let lineHeight = this.textHeight / (this.fontSize * this.lineNumber)

      let totalHieght =
        (this.textHeight / (this.fontSize * lineHeight)) *
        (lineHeight * this.fontSize)
      // console.log(lineHeight, totalHieght, this.textHeight)
      return {
        bottom: this.textHeight - totalHieght + 'px'
      }
    }
  },
  mounted () {
    this.calcHeight()
  }
}
</script>

<style scoped>
.container {
  position: relative;
  width: 300px;
  margin: 0 auto;
  overflow: hidden;
}

.container p {
  position: relative;
}
.ellipsis::after {
  position: absolute;
  content: '...';
  font-size: 16px;
  width: 30px;
  text-align: left;
  height: 16px;
  background: #fff;
  right: -3px;
  bottom: 0;
}
.dot {
  position: absolute;
  width: 18px;
  height: 30px;
  line-height: 35px;
  background: #fff;
  font-size: 0;
  right: 0;
  bottom: 0;
}
.dot b {
  font-size: 16px;
  display: inline-block;
  width: 2px;
  height: 2px;
  margin-right: 3px;
  font-family: '微软雅黑';
  border-radius: 50%;
  background: #000;
  font-weight: 100;
}
</style>



// WEBPACK FOOTER //
// src/components/TextEllipsis.vue